const makeConstant = constant => `metrics/${constant}`

export const SEND_DRIFT_APP_METRIC = makeConstant('SEND_DRIFT_APP_METRIC')
export const SEND_DRIFT_APP_METRIC_PENDING = makeConstant('SEND_DRIFT_APP_METRIC_PENDING')
export const SEND_DRIFT_APP_METRIC_FAILED = makeConstant('SEND_DRIFT_APP_METRIC_FAILED')
export const SEND_DRIFT_APP_METRIC_SUCCESS = makeConstant('SEND_DRIFT_APP_METRIC_SUCCESS')
